import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ProgressBar from "../components/ProgressBar";
import UserRegistrationForm from "../components/UserRegistrationForm";
import { calculateNaturalIntelligence } from "../services/testCalculations";
import { sendTestResultsEmail } from "../services/emailService";
import { exportToExcel } from "../services/excelService";

const questions = [
  "Мне нравятся правила, и я стараюсь их придерживаться.",
  "Я нахожу идеи, которые могут зарабатывать деньги.",
  "Я могу объяснить несколькими методами одно и то же, если человеку не понятно.",
  "Мне скучно, если у меня рутинная деятельность (однообразный трудовой процесс, который предполагает повторение одних и тех же действий).",
  "Я ценю достопримечательности, сохраню идеи и артефакты с течением времени.",
  "Я с удовольствием погружаюсь в творческие занятия.",
  "Я работаю эффективно, потому что управляю своим временем.",
  "В любой момент я готов(-а) отложить в сторону свои собственные дела, чтобы сделать другим доброе дело.",
  "Если обратитесь ко мне, я предоставлю четкие инструкции о том, как выполнить задачу.",
  "Я часто нахожу и исправляю ошибки.",
  "Я помогаю другим оставаться здоровыми, подтянутыми и сбалансированными.",
  "Я всегда преуспеваю, когда мне нужно выполнить или представить свою работу",
  "Я испытываю удовольствие, когда другие учатся.",
  "Я создаю новые концепции, инновации, изобретения.",
  "Я хорошо умею делегировать (передавать) ответственность и работать в многозадачности.",
  "Я предвижу потенциальные опасности и принимаю меры для их предотвращения.",
  "Для меня тело, ум и душа – это увлекательный мир.",
  "Я настойчив(-ва), находчив(-ва) в любом предпринимательском деле.",
  "Я путешествую в далекие места.",
  "Я предлагаю свою помощь, когда кто-то нуждается в ней.",
  "Я всегда нахожу наиболее эффективный способ выполнения работы.",
  "Я предлагаю часто обратную связь, чтобы помочь другим расширить свои знания или улучшить свою работу.",
  "Я встану на защиту слабых или обиженных, а также тех, кто не может защитить себя (включая животных).",
  "У меня жажда странствий и приключений.",
  "Я обожаю быть в центре внимания.",
  "Я всегда довожу дело до конца.",
  "Я смотрю на ситуации или проблемные вопросы иначе, чем другие.",
  "Я часто действую спонтанно, пробую что-то новое без подготовки.",
  "Я умело взаимодействую в команде и использую людей/способности/ресурсы",
  "Я забочусь о других, когда им плохо.",
  "Я поощряю и мотивирую других.",
  "Я обожаю дарить подарки другим.",
  "Я могу генерировать оригинальные идеи или произведения, имеющие ценность.",
  "Я всегда вмешиваюсь, когда кто-то ведет себя оскорбительно по отношению к другому человеку.",
  "Я выявляю проблемы в знаниях других.",
  "Я ставлю цели и составляю планы для их достижения.",
  "У меня много творческих занятий.",
  "Мне нравится прислуживать другим людям.",
  "Я люблю развлекать других людей.",
  "Я амбициозен(-на).",
  "Я присматриваюсь к здоровью пожилых членов семьи",
  "На меня всегда можно положиться, я считаю себя ответственным и справедливым.",
  "Мне нравится сочувственно выслушивать физические или эмоциональные проблемы людей и давать им советы.",
  "Я захватываю и постоянно удерживаю внимание других людей.",
  "Я легко умею решать сложные задачи.",
  "Я считаю, что тело, ум и душу нужно поддерживать в равновесии.",
  "Я отлично веду переговоры и заключаю выгодные сделки.",
  "Я понимаю, почему другие не понимают или не воспринимают что-то.",
  "Мне нравиться заставлять других людей смеяться.",
  "Я помню все дни рождения и праздники своих родных и друзей.",
  "Я всегда привожу эффективные примеры и аналогии в разговоре.",
  "У меня прекрасное чувство времени, окружения и самовыражения.",
  "Если кто-то находиться в опасности, я приду на помощь.",
  "Мне любопытно придумывать и создавать что-то новое.",
  "Меня подстегивает к активности обратная связь аудитории в виде аплодисментов, улыбок, смеха и высокой оценки моей работы.",
  "Я могу сделать что-то, что другие сочтут опасным.",
  "У меня есть увлечение, связанное с помощью людям и заботой о них.",
  "Я забочусь о других людях, когда им плохо.",
  "Я люблю собирать информацию из разных источников.",
  "Я предпочитаю работать самостоятельно.",
  "Я легко могу конкурировать с кем-то.",
  "Я регулярно проверю прогресс в выполнении своих планов.",
  "Я спокойно могу быть волонтером для социальных целей.",
  "Я люблю играть на публику и получать их внимание.",
  "Я получаю удовольствие от создания бизнеса и его финансовой ценности.",
  "Я смело экспериментирую в своей жизни.",
  "Я получаю удовольствие, когда помогаю другим людям решать их внутренние эмоциональные проблемы.",
  "Я не позволяю другим быть расточительными (тратить деньги по пусту).",
  "Я с легкостью иду на риски (социальные, физические, умственные, финансовые).",
  "Я люблю мозговые штурмы.",
  "Мне нравиться помогать другим научаться что-то делать и понять, как это делать.",
  "Я легко пожертвую деньги или личные вещи нуждающимся.",
  "Я с легкостью начну собственное дело, объединяя различные ресурсы.",
  "Я чувствую энергетику других людей, вижу их состояние, понимаю, как им лучше восстановиться.",
  "Я люблю организовывать мероприятия и уделять внимание к деталям.",
  "Я являюсь гибким человеком и могу демонстрировать лидерство.",
  "Мне нравятся приключенческие и экстремальные виды спорта.",
  "Я люблю выступать и шутить на публику.",
  "Если моя помощь сделает человека счастливым я обязательно ему помогу.",
  "Я тщательно слежу за бюджетом и грамотно трачу деньги.",
  "Я выхожу за рамки и принимаю риски."
];

const NaturalIntelligenceTest = () => {
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [answers, setAnswers] = useState({});
  const [currentValue, setCurrentValue] = useState('');
  const [userInfo, setUserInfo] = useState({
    full_name: "",
    email: "",
    phone: ""
  });
  const [isStarted, setIsStarted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const savedAnswers = localStorage.getItem('naturalIntelligenceAnswers');
    if (savedAnswers) {
      setAnswers(JSON.parse(savedAnswers));
    }
    // Инициализируем currentValue для первого вопроса
    setCurrentValue(answers[1]?.toString() || '');
  }, []);

  const handleStart = () => {
    setIsStarted(true);
  };

  const handleAnswerChange = (value) => {
    // Заменяем запятую на точку
    const normalizedValue = value.replace(',', '.');
    setCurrentValue(normalizedValue);
    
    // Валидация: проверяем, что значение находится в диапазоне 0-2
    const numValue = parseFloat(normalizedValue);
    if (!isNaN(numValue) && numValue >= 0 && numValue <= 2) {
      setAnswers({
        ...answers,
        [currentQuestion + 1]: numValue
      });
    } else if (normalizedValue === '' || normalizedValue === '0' || normalizedValue === '1' || normalizedValue === '2') {
      // Разрешаем пустое значение и целые числа
      setAnswers({
        ...answers,
        [currentQuestion + 1]: parseFloat(normalizedValue) || 0
      });
    }
  };

  const isValidValue = (value) => {
    const normalizedValue = value.replace(',', '.');
    const numValue = parseFloat(normalizedValue);
    return !isNaN(numValue) && numValue >= 0 && numValue <= 2;
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' || e.key === 'Return') {
      if (currentValue && currentValue !== '' && isValidValue(currentValue) && !isLastQuestion) {
        nextQuestion();
      } else if (currentValue && currentValue !== '' && isValidValue(currentValue) && isLastQuestion) {
        submitTest();
      }
    }
  };

  const parsedAnswers = {};
  Object.entries(answers).forEach(([q, val]) => {
    const num = parseFloat(val);
    // parsedAnswers[q] = !isNaN(num) && num >= 0 && num <= 2 ? num : 0; // || 0 - чтобы 0 не считался "пустым значением".
    parsedAnswers[q] = Math.min(2, Math.max(0, num || 0));
  });

  const nextQuestion = () => {
    if (currentQuestion < questions.length - 1) {
      setCurrentQuestion(currentQuestion + 1);
      setCurrentValue(answers[currentQuestion + 2]?.toString() || '');
    }
  };

  const prevQuestion = () => {
    if (currentQuestion > 0) {
      setCurrentQuestion(currentQuestion - 1);
      setCurrentValue(answers[currentQuestion]?.toString() || '');
    }
  };

  const submitTest = async () => {
    setIsSubmitting(true);
    try {
      // Calculate results on frontend
      const testResult = calculateNaturalIntelligence(parsedAnswers);
      testResult.userInfo = userInfo;
      
      // Send email with detailed results and Excel attachment
      const emailResult = await sendTestResultsEmail(testResult, 'natural_intelligence');
      
      if (emailResult.success) {
        console.log('✅ Email sent successfully');
        if (emailResult.excelCreated) {
          console.log(`📊 Excel file created: ${emailResult.excelFileName}`);
        }
      } else {
        console.error('❌ Email sending failed:', emailResult.error);
      }
      
      // Создаем Excel файл для скачивания (для тестирования)
      const excelResult = exportToExcel(testResult);
      if (excelResult.success) {
        console.log(`📁 Excel file created: ${excelResult.fileName}`);
      } else {
        console.error('❌ Excel creation failed:', excelResult.error);
      }
      
      // Store results for display (only basic info)
      const displayResult = {
        id: Date.now().toString(),
        test_type: 'natural_intelligence',
        user_info: userInfo,
        results: {
          categories: testResult.allCategories,
          dominant_type: testResult.dominantType,
          summary: testResult.summary
        },
        timestamp: new Date().toISOString()
      };
      
      // Store in localStorage for display
      localStorage.setItem('lastTestResult', JSON.stringify(displayResult));
      
      // Navigate to thank you page instead of results
      navigate('/thank-you');
      
    } catch (error) {
      console.error("Error submitting test:", error);
      alert("Ошибка при отправке результатов. Попробуйте еще раз.");
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isStarted) {
    const testDescription = (
      <div>
        <div className="mb-6 p-4 bg-green-50 rounded-md">
        <h3 className="font-semibold text-green-800 mb-2">О тесте:</h3>
        <p className="text-green-700 text-sm mb-2">
        Каждый человек рождается с врожденными склонностями, которые усиливаются нашим окружением — особенно на ранних стадиях жизни. Эти черты влияют на то, как мы действуем и к какому виду деятельности нас тянет.
        </p>
      </div>
      <div className="mb-6 p-4 bg-yellow-50 rounded-md">
        <h3 className="font-semibold text-yellow-800 mb-2">Инструкция:</h3>
        <p className="text-yellow-700 text-sm mb-2">
          Отметьте номера утверждений, которые Вам соответствуют цифрами от 0 до 2.
        </p>
        <ul className="text-yellow-700 text-sm list-disc list-inside">
          <li>Если полностью согласны (100%) = 1</li>
          <li>Если частично (например, 37% = 0.37, 83% = 0.83)</li>
          <li>Если более чем уверены (до 200%, например, 1.18, 1.43, 1.79) = до 2</li>
          <li>Если не согласны = 0</li>
        </ul>
      </div>
      </div>
    );

    return (
      <UserRegistrationForm
        userInfo={userInfo}
        setUserInfo={setUserInfo}
        onStart={handleStart}
        testTitle="Тест по природным интеллектам"
        testDescription={testDescription}
        buttonText="Начать тест (81 вопрос)"
      />
    );
  }

  const isLastQuestion = currentQuestion === questions.length - 1;
  // const currentAnswer = answers[currentQuestion + 1] || "";
  const currentAnswer = answers[currentQuestion + 1] ?? ""; // ?? nullish coalescing operator, чтобы 0 не считался "пустым значением".

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="max-w-3xl mx-auto">
        <div className="bg-white p-8 rounded-lg shadow-md">
          <ProgressBar current={currentQuestion + 1} total={questions.length} className="mb-8" />
          
          <div className="mb-8">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">
              Вопрос {currentQuestion + 1}
            </h2>
            <p className="text-gray-700 text-lg mb-6">
              {questions[currentQuestion]}
            </p>
            
            <div className="space-y-4" onKeyPress={handleKeyPress}>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Введите значение от 0 до 2:
                </label>
                <input
                  type="text"
                  value={currentValue}
                  onChange={(e) => handleAnswerChange(e.target.value)}
                  className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:border-transparent ${
                    currentValue && currentValue !== '' 
                      ? (isValidValue(currentValue)
                          ? 'border-green-500 focus:ring-green-500' 
                          : 'border-red-500 focus:ring-red-500')
                      : 'border-gray-300 focus:ring-green-500'
                  }`}
                  placeholder="0.00 - 2.00 (например: 0.2, 1.32, 1.5)"
                />
                {currentValue && currentValue !== '' && !isValidValue(currentValue) && (
                  <p className="text-red-500 text-xs mt-1">Пожалуйста, введите значение от 0 до 2 (используйте точку как десятичный разделитель)</p>
                )}
              </div>
              
              <div className="bg-blue-50 p-3 rounded text-sm">
                <p className="text-blue-800 font-medium mb-1">Примеры значений:</p>
                <ul className="text-blue-700 space-y-1">
                  <li>• Полностью согласны (100%) = 1.00</li>
                  <li>• Частично согласны (37%) = 0.37</li>
                  <li>• Более чем уверены (118%) = 1.18</li>
                  <li>• Не согласны = 0.00</li>
                </ul>
              </div>
              
              <p className="text-xs text-gray-500 mt-2">
                Нажмите Enter для перехода к следующему вопросу
              </p>
            </div>
          </div>

          <div className="flex justify-between">
            <button
              onClick={prevQuestion}
              disabled={currentQuestion === 0}
              className="px-6 py-2 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Назад
            </button>
            
            {isLastQuestion ? (
              <button
                onClick={submitTest}
                disabled={isSubmitting || !currentValue || currentValue === '' || !isValidValue(currentValue)}
                className="px-6 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isSubmitting ? "Отправка..." : "Завершить тест"}
              </button>
            ) : (
              <button
                onClick={nextQuestion}
                disabled={!currentValue || currentValue === '' || !isValidValue(currentValue)}
                className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Далее
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NaturalIntelligenceTest;
